import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory, useLocation } from 'react-router-dom'

import VirtualGift from '../virtualGifts/VirtualGift'
import Button from '../../ui/button'

import { MyGift } from '../../../store/member/memberTypings'
import { createLocalizedPath } from '../../../utils/localizationHelpers'
import isEmpty from 'lodash/isEmpty'
import paths from '../../../paths'
import s from './materialPreview.module.sass'
import { useSelector } from 'react-redux'
import { RootState } from '../../../store/rootReducer'
import { ProfileState } from '../../../store/profile/profileTypings'
import ButtonLink from '../../ui/buttonLink'

interface Props {
    recipient: string
    gifts: MyGift[]
    isOutgoing?: boolean
}

const GiftsPreview = ({ recipient, gifts, isOutgoing = true }: Props) => {
    const [t] = useTranslation()
    const history = useHistory()
    const location = useLocation()

    const emptyGifts = isEmpty(gifts)
    const self = location.pathname.includes('/membre')

    const { user } = useSelector<RootState, ProfileState>((state) => state.profile)

    const giveGift = () => {
        history.push({
            pathname: createLocalizedPath(paths.virtualGiftCatalog.path),
            search: `?r=` + recipient
        })
    }

    return (
        <div className={s['materialsPreview']}>
            <div className={s['materialsPreview__row']}>
                <div className={s['materialsPreview__title']}>{t('Virtual gifts')}</div>
                <div className={s['materialsPreview__counter']}>{!emptyGifts && gifts.length}</div>
                {self ? <></> : <Button label={t('Give a virtual gift')} small onClick={giveGift} />}
            </div>
            {emptyGifts ? (
                self ? (
                    <div className={s['materialsPreview__emptyPlaceholder']}>
                        <div className={s['header']}>{t('You dont have any gifts')}</div>
                    </div>
                ) : (
                    <div className={s['materialsPreview__emptyPlaceholder']}>
                        <div className={s['header']}>
                            {recipient} {t('doesnt have any gifts')}
                        </div>
                    </div>
                )
            ) : (
                <div className={s['materialsPreview__list']}>
                    {gifts
                        .filter((item: MyGift, index: number) => index < 4)
                        .map((item: MyGift, index: React.Key) => (
                            <VirtualGift
                                virtualGift={item}
                                short
                                album
                                userAlbum={!self}
                                key={index}
                                isOutgoing={isOutgoing}
                            />
                        ))}
                </div>
            )}
            {!emptyGifts && !self ? (
                <ButtonLink
                    label={t('All virtual gifts')}
                    linkUrl={createLocalizedPath(paths.profileGifts.toPath({ nick: user.nick }))}
                    secondary
                />
            ) : (
                !emptyGifts && (
                    <ButtonLink
                        label={t('All my virtual gifts')}
                        secondary
                        linkUrl={createLocalizedPath(paths.myVirtualGifts.path)}
                    />
                )
            )}
        </div>
    )
}

export default GiftsPreview
